import ProgressBar from '@components/ProgressBar';
import { usePromiseTracker } from 'react-promise-tracker';

export const AppLoadingIndicator = (): JSX.Element | null => {
  const { promiseInProgress } = usePromiseTracker();
  return promiseInProgress ? <ProgressBar /> : null;
};
